import React from "react";
import PageScaffold from "../../components/PageScaffold";
import { Box } from "@chakra-ui/react";

const Reports = () => {
  return (
    <PageScaffold title="Reports" isHeaderVisible={true}>
      <Box height="calc(100vh - 64px)" width="100%">
        <iframe
          src="https://garaaz.retool.com/apps/Order%20%26%20Invoice%20Dashboard"
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="Reports"
        />
      </Box>
    </PageScaffold>
  );
};

export default Reports;
